module.exports = __webpack_public_path__ + "static/media/anuncio.45066547.svg";